/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

export const candidateEventResponseType = {
	invitation_created: 'invitation_created',
	invitation_sent: 'invitation_sent',
	invitation_superseded: 'invitation_superseded',
	invitation_expired: 'invitation_expired',
	booking_confirmed: 'booking_confirmed',
	booking_cancelled: 'booking_cancelled',
	stage_changed: 'stage_changed',
	email_sent: 'email_sent',
	email_received: 'email_received',
	whatsapp_sent: 'whatsapp_sent',
	whatsapp_received: 'whatsapp_received',
	applied: 'applied',
} as const

export type CandidateEventResponseType = (typeof candidateEventResponseType)[keyof typeof candidateEventResponseType]
